// import request from '@/utils/request'
import axios from 'axios'
import global from '@/global/variable.js'


// 获取人脸闸机列表
export function getHistoryList(data) {
  const url = global.requestUrl + '/personAccess/list?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.startDate + '&endDate=' + data.endDate 
              + '&gate=' + data.gate + '&type=' + data.type + '&name=' + data.name
  return axios.get(url)
}

// 人脸闸机放行
export function updateOne(data) {
  const url = global.requestUrl + '/equip/openDoor?gate=' + data.gate + '&reason=' + data.reason
  return axios.get(url)
}

